import { render, staticRenderFns } from "./FooterSpNavigation.vue?vue&type=template&id=551272db"
import script from "./FooterSpNavigation.vue?vue&type=script&lang=js"
export * from "./FooterSpNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports